// extracted by mini-css-extract-plugin
export default {"button":"placeholders_button__ZVaDi"};